"use client";

import Link from "next/link";
import { useState } from "react";
import {
  LuBox,
  LuEllipsis as LuMoreHorizontal,
  LuSend,
  LuTarget,
  LuUsers as LuUsers2,
} from "react-icons/lu";

import { Button } from "@/components/ui/button";
import {
  DropdownDrawer,
  DropdownDrawerContent,
  DropdownDrawerItem,
  DropdownDrawerTrigger,
} from "@/components/ui/dropdown-drawer";

const ACTIONS_ITEMS = [
  {
    text: "Buy on Diamond",
    icon: <LuBox className="size-4 text-muted" />,
  },
  {
    text: "Sell on Diamond",
    icon: <LuTarget className="size-4 text-muted" />,
  },
  {
    text: "Send on Diamond",
    icon: <LuSend className="size-4 text-muted" />,
  },
  {
    text: "View Holders",
    icon: <LuUsers2 className="size-4 text-muted" />,
  },
];

const CreatorCoinV1Actions = ({ userName }: { userName: string }) => {
  const [open, setOpen] = useState(false);

  return (
    <DropdownDrawer
      historyName="creator-coin-v1-actions"
      open={open}
      onOpenChange={setOpen}
      title="Creator coin actions"
    >
      <DropdownDrawerTrigger
        render={
          <Button
            variant="outline"
            size="icon"
            className="
              size-full rounded-full border-none text-sm
              hover:bg-transparent
            "
          >
            <LuMoreHorizontal className="size-4" />
          </Button>
        }
      />{" "}
      <DropdownDrawerContent sideOffset={-8}>
        {ACTIONS_ITEMS.map(({ text, icon }) => (
          <DropdownDrawerItem
            key={text}
            render={
              <Link
                href={`${process.env.NEXT_PUBLIC_DIAMOND_APP_URI}/u/${userName}?tab=creator-coin`}
                className="flex items-center gap-2"
                target="_blank"
              >
                {icon}
                <span>{text}</span>
              </Link>
            }
          />
        ))}
      </DropdownDrawerContent>
    </DropdownDrawer>
  );
};

export default CreatorCoinV1Actions;
